import React from 'react'
import {RouterProvider} from "react-router";
import {router} from '@/components/router'
import {AuthProvider} from "../contexts/auth_context";
import {ToastProvider} from "./ui/toast";

export const App = () => {
  return <ToastProvider>
    <AuthProvider>
    <RouterProvider router={router} />
  </AuthProvider>
  </ToastProvider>
};
